<div class="container" [ngClass]="{'large': !isMobile}">
  <div mat-dialog-title class="ds" >
    <span>{{ appStrings.products_gridLineNotes }}</span>
    <button mat-icon-button class="close-dialog-button" mat-dialog-close>
      <mat-icon id="closeButton" class="close-icon">close</mat-icon>
    </button>
  </div>
  <div id="formContainer" mat-dialog-content class="content ds">
    <form [formGroup]="notesForm">
      <div id="searchFormContent" class="product-container">
        <div class="multiline-container">
          <ds-multiline id="lineNotes" class="fill-width" [label]="appStrings.products_gridLineNotes" label_orientation="vertical-label"
            [control]="notesForm.controls.lineNotes" maxLength="2000">
          </ds-multiline>
        </div>
        @if (bomNotes) {
          <div class="multiline-container">
            <ds-multiline id="bomNotes" class="fill-width" [label]="appStrings.products_gridBomNotes" label_orientation="vertical-label"
              [control]="notesForm.controls.bomNotes">
            </ds-multiline>
          </div>
        }
      </div>
    </form>
  </div>
  <div id="dialog-actions" mat-dialog-actions align="end" class="ds">
    <div class="dialog-btn-wrapper">
      <ds-button id="closeButton" variant="label-only" size="medium" type="secondary" (onClick)="close()"
        [label]="appStrings.button_close">
      </ds-button>
      <ds-button id="addButton" variant="label-only" size="medium" type="primary" (onClick)="closeAndSave()"
        [label]="appStrings.button_save" [isDisabled]="!notesForm.valid">
      </ds-button>
    </div>
  </div>
</div>
